import type { FC } from "react";
import { cn } from "./utils/cn";

interface FieldErrorProps {
  children?: React.ReactNode;
  id?: string;
  className?: string;
}

/** Inline validation message shown beneath a field. */
const FieldError: FC<FieldErrorProps> = ({ children, id, className }) => {
  if (!children) return null;
  return (
    <p id={id} className={cn("mt-1 text-start text-sm text-danger", className)}>
      {children}
    </p>
  );
};

export default FieldError;
